import banner from "../../../courses/presupuesto-ahorro.webp";

const modulo9 = {
  courseId: "cripto-blockchain",
  id: "modulo-9",
  title: "🧪 Módulo 9: Evaluación Final",
  estimatedDuration: "30–45 minutos",
  format: "Examen final en línea + reflexión opcional",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos del módulo",
      content: [
        {
          type: "list",
          items: [
            "Verificar que comprendes los conceptos clave del ecosistema cripto.",
            "Validar tu preparación para interactuar con el mundo Web3 de forma segura y consciente.",
            "Obtener tu Certificado Profesional ZyVerse en Cripto y Blockchain.",
          ],
        },
      ],
    },
    {
      id: "info",
      navLabel: "¿Qué incluye esta evaluación?",
      title: "📝 ¿Qué incluye esta evaluación?",
      content: [
        {
          type: "paragraph",
          text: "📌 Examen final",
        },
        {
          type: "list",
          items: [
            "20 preguntas de opción múltiple",
            "Basadas en los módulos 1 a 8",
            "Temas: blockchain, criptomonedas, stablecoins, wallets, seguridad, Web3, DeFi, NFTs",
            "Duración estimada: 25–30 minutos",
            "Nota mínima aprobatoria: 60% de aciertos",
          ],
        },
      ],
    },
    {
      id: "luego-examen",
      navLabel: "¿Qué pasa después del examen?",
      title: "📤 ¿Qué pasa después del examen?",
      content: [
        {
          type: "list",
          items: [
            "Si obtienes 10 respuestas correctas o más, podrás acceder al pago del certificado ($200 MXN).",
            "El certificado será emitido en formato PDF en un plazo de 3 a 5 días hábiles.",
            "Podrás usarlo para acreditar horas complementarias, fortalecer tu CV o compartirlo en LinkedIn.",
          ],
        },
      ],
    },
    {
      id: "examen-final",
      navLabel: "Examen Final",
      title: "📝 Examen final (sin respuestas marcadas)",
      questions: [
        {
          id: "q1",
          question: "¿Cuál es el objetivo principal de una blockchain?",
          options: [
            { key: "a", text: "Guardar fotos y videos" },
            { key: "b", text: "Validar datos personales" },
            {
              key: "c",
              text: "Registrar transacciones de forma segura y descentralizada",
            },
            { key: "d", text: "Generar dinero automáticamente" },
          ],
          correct: "c",
        },
        {
          id: "q2",
          question: "¿Qué hace única a la tecnología blockchain?",
          options: [
            { key: "a", text: "Su velocidad" },
            { key: "b", text: "El uso de bancos tradicionales" },
            {
              key: "c",
              text: "Su transparencia y resistencia a manipulaciones",
            },
            { key: "d", text: "Solo funciona con Bitcoin" },
          ],
          correct: "c",
        },
        {
          id: "q3",
          question: "¿Cuál es la criptomoneda conocida como “oro digital”?",
          options: [
            { key: "a", text: "Ethereum" },
            { key: "b", text: "Bitcoin" },
            { key: "c", text: "Solana" },
            { key: "d", text: "USDT" },
          ],
          correct: "b",
        },
        {
          id: "q4",
          question:
            "¿Qué red es conocida por sus contratos inteligentes y aplicaciones descentralizadas?",
          options: [
            { key: "a", text: "Polygon" },
            { key: "b", text: "Ethereum" },
            { key: "c", text: "Stellar" },
            { key: "d", text: "Binance" },
          ],
          correct: "b",
        },
        {
          id: "q5",
          question: "¿Qué caracteriza a las stablecoins?",
          options: [
            { key: "a", text: "Su volatilidad extrema" },
            { key: "b", text: "Solo sirven en juegos" },
            { key: "c", text: "Mantienen un valor estable, como 1 dólar" },
            { key: "d", text: "Funcionan sin respaldo" },
          ],
          correct: "c",
        },
        {
          id: "q6",
          question: "¿Cuál es la función de una wallet?",
          options: [
            { key: "a", text: "Guardar y gestionar tus criptoactivos" },
            {
              key: "b",
              text: "Convertir cripto en dinero físico automáticamente",
            },
            { key: "c", text: "Comprar productos directamente" },
            { key: "d", text: "Sustituir tu banco" },
          ],
          correct: "a",
        },
        {
          id: "q7",
          question: "¿Qué es una seed phrase?",
          options: [
            { key: "a", text: "Una tarjeta de crédito" },
            { key: "b", text: "Un código QR" },
            {
              key: "c",
              text: "Un conjunto de palabras que permite recuperar tu wallet",
            },
            { key: "d", text: "El nombre de usuario en la blockchain" },
          ],
          correct: "c",
        },
        {
          id: "q8",
          question: "¿Qué tipo de wallet ofrece más control al usuario?",
          options: [
            { key: "a", text: "Custodial" },
            { key: "b", text: "Non-custodial" },
            { key: "c", text: "Digital" },
            { key: "d", text: "Bancaria" },
          ],
          correct: "b",
        },
        {
          id: "q9",
          question: "¿Qué puede pasar si compartes tu seed phrase?",
          options: [
            { key: "a", text: "Te llegará más cripto" },
            { key: "b", text: "No pasa nada" },
            { key: "c", text: "Alguien puede robar todos tus fondos" },
            { key: "d", text: "Solo pierdes el acceso por unas horas" },
          ],
          correct: "c",
        },
        {
          id: "q10",
          question: "¿Cuál es un ejemplo de red con comisiones muy bajas?",
          options: [
            { key: "a", text: "Ethereum" },
            { key: "b", text: "Stellar" },
            { key: "c", text: "Bitcoin" },
            { key: "d", text: "Binance Smart Chain" },
          ],
          correct: "b",
        },
        {
          id: "q11",
          question: "¿Qué es DeFi?",
          options: [
            { key: "a", text: "Una empresa de tecnología" },
            { key: "b", text: "Una criptomoneda nueva" },
            {
              key: "c",
              text: "Un sistema financiero sin bancos ni intermediarios",
            },
            { key: "d", text: "Un juego basado en blockchain" },
          ],
          correct: "c",
        },
        {
          id: "q12",
          question: "¿Para qué sirve un explorador blockchain?",
          options: [
            { key: "a", text: "Para jugar con NFTs" },
            { key: "b", text: "Para revisar transacciones públicas en la red" },
            { key: "c", text: "Para minar criptomonedas" },
            { key: "d", text: "Para cambiar tu clave privada" },
          ],
          correct: "b",
        },
        {
          id: "q13",
          question:
            "¿Cuál es la diferencia principal entre token y criptomoneda?",
          options: [
            { key: "a", text: "El token vive dentro de una red ya existente" },
            { key: "b", text: "La criptomoneda es más segura" },
            { key: "c", text: "El token solo se usa en juegos" },
            { key: "d", text: "Son exactamente iguales" },
          ],
          correct: "a",
        },
        {
          id: "q14",
          question: "¿Qué es un NFT?",
          options: [
            {
              key: "a",
              text: "Un activo digital único con propiedad verificada",
            },
            { key: "b", text: "Una moneda estable" },
            { key: "c", text: "Un contrato de trabajo" },
            { key: "d", text: "Un archivo sin valor" },
          ],
          correct: "a",
        },
        {
          id: "q15",
          question: "¿Qué debes revisar antes de enviar criptomonedas?",
          options: [
            { key: "a", text: "El nombre del receptor" },
            { key: "b", text: "La red correcta y la compatibilidad del token" },
            { key: "c", text: "El color del ícono" },
            { key: "d", text: "Que sea de noche" },
          ],
          correct: "b",
        },
        {
          id: "q16",
          question: "¿Qué es phishing en el mundo cripto?",
          options: [
            { key: "a", text: "Un nuevo tipo de token" },
            { key: "b", text: "Un error al enviar" },
            {
              key: "c",
              text: "Un intento de estafa mediante enlaces falsos o correos engañosos",
            },
            { key: "d", text: "El proceso para comprar tokens" },
          ],
          correct: "c",
        },
        {
          id: "q17",
          question: "¿Qué es un airdrop?",
          options: [
            {
              key: "a",
              text: "Recompensa en cripto que recibes gratuitamente",
            },
            { key: "b", text: "Una nueva wallet" },
            { key: "c", text: "Un error de red" },
            { key: "d", text: "Un tipo de scam" },
          ],
          correct: "a",
        },
        {
          id: "q18",
          question: "¿Qué ofrece una plataforma como Stellar Quest?",
          options: [
            { key: "a", text: "Comprar autos en línea" },
            { key: "b", text: "Aprender jugando mientras ganas XLM" },
            { key: "c", text: "Cambiar dólares por criptos directamente" },
            { key: "d", text: "Abrir una cuenta bancaria" },
          ],
          correct: "b",
        },
        {
          id: "q19",
          question: "¿Qué diferencia hay entre Vesseo y un banco tradicional?",
          options: [
            { key: "a", text: "Vesseo no guarda tu dinero en efectivo" },
            {
              key: "b",
              text: "Vesseo no controla tus fondos: tú tienes la custodia",
            },
            { key: "c", text: "Vesseo cobra intereses" },
            { key: "d", text: "No hay ninguna diferencia" },
          ],
          correct: "b",
        },
        {
          id: "q20",
          question: "¿Cuál es la filosofía del curso?",
          options: [
            { key: "a", text: "Gana dinero rápido" },
            {
              key: "b",
              text: "Entiende antes de invertir y actúa con seguridad",
            },
            { key: "c", text: "Compra cripto y olvida lo demás" },
            { key: "d", text: "Toda inversión da ganancias" },
          ],
          correct: "b",
        },
      ],
    },
    {
      id: "finalizacion",
      navLabel: "¡Felicitaciones por llegar hasta aquí!",
      title: "🎖️ ¡Felicitaciones por llegar hasta aquí!",
      content: [
        "“Invertir en tu educación financiera y digital es una de las mejores decisiones que puedes tomar.”",
      ],
    },

    {
      id: "reflexion-final",
      navLabel: "Reflexión final",
      title: "💭 Reflexión final (opcional, pero recomendada)",
      content: [
        {
          type: "paragraph",
          text: "Tema sugerido:",
        },
        {
          type: "paragraph",
          text: "“¿Qué aprendí y cómo lo aplicaré?”",
        },
        {
          type: "paragraph",
          text: "Puedes redactar un texto breve (1 a 2 cuartillas), o grabar un audio o video corto, donde compartas:",
        },
        {
          type: "list",
          items: [
            "¿Qué módulos te impactaron más?",
            "¿Qué hábitos has cambiado o piensas cambiar?",
            "¿Qué aprendiste sobre ti y tu relación con el dinero digital?",
            "¿Cómo usarás estos conocimientos en tu vida personal o profesional?",
          ],
        },
      ],
    },
  ],
};

export default modulo9;
